import React, { Component } from 'react';
import Collapsible from 'react-collapsible';
import cn from 'classnames'; // to use global class name eg. classes from grid.css in public folder
import Button from 'react-toolbox/lib/button';
import Input from 'react-toolbox/lib/input';// to use input from react-toolbox library
import Error from 'components/ErrorMessage';// to display error messages on invalid user input
import { is } from 'immutable'; // use of immutablejs for various js operations to simplify our work
import PropTypes from 'prop-types'; // to validate and set default props  coming to this component
import renderIf from 'render-if';// to use conditional rendering based on values that is provided to component
import FullScreenLoader from 'components/FullScreenLoader';// to show loder on screen whenever there is a api call or operations in component
import { regExForName } from 'constants/Regularexpression'; // regular expressions to validate user input

import { RadioGroup, RadioButton } from 'react-toolbox/lib/radio';

import styles from './ModifyParent.scss';// to import local scss fle

class ModifyParent extends Component {
  static propTypes = {
    getSAProfile: PropTypes.func,
    saveSAProfile: PropTypes.func,
    attributes: PropTypes.shape(),
    profile: PropTypes.shape(),
    saRequested: PropTypes.bool,
    updateRequested: PropTypes.bool,
      /* searchSchools: PropTypes.func, */
  };

  static defaultProps = {
    getSAProfile: () => {},
    saveSAProfile: () => {},
    attributes: {},
    profile: {},
    saRequested: true,
    updateRequested: false,
    searchSchools: () => {},
  };
  constructor(props) {
    super(props);
    this.state = {
      value: '',
          /* parent info fields */
      parentGender: 'male',
      parentFullNameErrorMessage: '',
      parentEmailErrorMessage: '',
      parentMobileNumberErrorMessage: '',
      parentFullName: '',
      parentEmail: '',
      mobileNumber: '',
          /* parent info fields */

          /* student info fields */
      studentGender: 'male',
      studentFullName: '',
      studentCity: '',
      studentState: '',
      studentFullNameErrorMessage: '',
      studentEmailErrorMessage: '',
      studentStateErrorMessage: '',
      studentCityErrorMessage: '',
          /* student info fields */

          /* student sports info */
      position_pref: '',
      height: '',
      weight: '',
      sportName: 'FOOTBALL',
      t40: '',
      bench: '',
      squats: '',
      positions: '',
      description: '',
      heightErrorMessage: '',
      weightErrorMessage: '',
      mySport: 'FOOTBALL',
      t40ErrorMessage: '',
      squatsErrorMessage: '',
      benchErrorMessage: '',
      descriptionErrorMessage: '',
          /* student sports info */

          /* academic info */
      school: '',
      gpa: '',
      act: '',
      sat: '',
      yearOfPassing: '',
      schoolErrorMessage: '',
      yearOfPassingErrorMessage: '',
      gpaErrorMessage: '',
      satErrorMessage: '',
      actErrorMessage: '',
          /* academic info */
      parentCollapsible: true,
      emailErrorMessage: '',
      firstNameErrorMessage: '',
    };
    this.validateInput = this.validateInput.bind(this);
    this.handleChange = this.handleChange.bind(this);
  }
  componentWillMount() {
    if (this.props.attributes.size > 0) {
      const profile = this.props.attributes.get('profile');
      this.props.getSAProfile(profile);
    }
  }
  componentWillReceiveProps(nextProps) {
    if (is(this.props.profile, nextProps.profile) && nextProps.saRequested) {
      if (nextProps.attributes.size > 0) {
        const profile = nextProps.attributes.get('profile');
        this.props.getSAProfile(profile);
      }
    }
    const newState = {};
    if (nextProps.profile.size > 0) {
      const saSports = nextProps.profile.get('sports');
      const keys = saSports.keySeq().toArray();
      const sport = saSports.get(keys[0]);
      const academic = nextProps.profile.get('academic');
      newState.studentFullName = nextProps.profile.get('fullname');
      newState.studentGender = nextProps.profile.get('gender');
      newState.studentState = nextProps.profile.get('sa_state');
      newState.studentCity = nextProps.profile.get('city');
      newState.height = nextProps.profile.get('height');
      newState.weight = nextProps.profile.get('weight');
      newState.sportName = keys[0];
      newState.t40 = sport.get('t40');
      newState.bench = sport.get('bench');
      newState.squats = sport.get('squats');
      newState.description = sport.get('description');
      newState.position = sport.get('position_pref');
      newState.school = nextProps.profile.get('school');
      newState.yearOfPassing = academic.get('year_of_graduation');
      newState.gpa = academic.get('gpa');
      newState.sat = academic.get('sat');
      newState.act = academic.get('act');
    }
    this.setState({ ...newState });
  }
  handleChange(name, value) {
    this.setState({ ...this.state, [name]: value });
  }

  removeErrorMessage(name) {
    this.setState({ ...this.state, [name]: '' });
  }

  validateInput() {
    const { parentFullName, studentFullName,
            studentCity, studentState } = this.state;
      /* validation personal info */
    let parentValidFullName = false;
    const updated = {};
      /* validation for Full Name */
    const enteredFullName = regExForName.test(parentFullName);
    if (enteredFullName && parentFullName !== '') {
      parentValidFullName = true;
    } else {
      updated.parentFullNameErrorMessage = 'Please enter a valid name.';
    }
      /* validation for Full Name */
      /* validation for student info */
    let validStudentFullName = false;
    let validStudentCity = false;
    let validStudentState = false;

      /* validation for Full Name */
    const enteredStudentFullName = regExForName.test(studentFullName);
    if (enteredStudentFullName && studentFullName !== '') {
      validStudentFullName = true;
    } else {
      updated.studentFullNameErrorMessage = 'Please enter a valid name.';
    }
      /* validation for Full Name */

      /* validation for city */
    const enteredStudentCity = regExForName.test(studentCity);
    if (enteredStudentCity && studentCity !== '') {
      validStudentCity = true;
    } else {
      updated.studentCityErrorMessage = 'Please enter a valid city.';
    }
      /* validation for city */

      /* validation for state */
    const enteredStudentState = regExForName.test(studentState);
    if (enteredStudentState && studentState !== '') {
      validStudentState = true;
    } else {
      updated.studentStateErrorMessage = 'Please enter a valid state.';
    }
      /* validation for student info */

      /* validation for sports info */
      /* Height Validation */
    let validHeight = false;

    if (this.state.height !== '') {
      validHeight = true;
    } else {
      updated.heightErrorMessage = 'Enter valid height.';
    }
      /* Height Validation */

      /* weight validation */
    let validWeight = false;
    if (this.state.weight !== '') {
      validWeight = true;
    } else {
      updated.weightErrorMessage = 'Please add a valid weight.';
    }
      /* weight validation */

      /* Preferred Position validation */
      /* let validPosition = false;
       if (this.state.position_pref !== '') {
       validPosition = true;
       } else {
       updated.positionErrorMessage = 'Please select preferred position.';
       } */
      /* Preferred Position validation */

      /* description validation */
    let validDescription = false;
    if (this.state.description !== '') {
      validDescription = true;
    } else {
      updated.descriptionErrorMessage = 'Please add description.';
    }
      /* description validation */

      /* T40 validation */
    let validT40 = false;
    if (this.state.t40 !== '') {
      validT40 = true;
    } else {
      updated.t40ErrorMessage = 'Please add a valid T40.';
    }
      /* T40 validation */

      /* squats validation */
    let validSquats = false;
    if (this.state.t40 !== '') {
      validSquats = true;
    } else {
      updated.squatsErrorMessage = 'Please add a valid Squats.';
    }
      /* squats validation */

      /* Bench validation */
    let validBench = false;
    if (this.state.t40 !== '') {
      validBench = true;
    } else {
      updated.benchErrorMessage = 'Please add a valid Bench.';
    }
      /* squats validation */
      /* validation for sports info */

      /* validation for academic info */
    let validSchool = false;
    const enteredScool = regExForName.test(this.state.school);
    if (enteredScool && this.state.school !== '') {
      validSchool = true;
    } else {
      updated.schoolErrorMessage = 'Please select a school.';
    }
      /* school validation */

      /* year of passing */
    let validYearOfPassing = false;

    if (this.state.yearOfPassing !== '') {
      validYearOfPassing = true;
    } else {
      updated.yearOfPassingErrorMessage = 'Please add graduation year.';
    }
      /* year of passing */

      /* Gpa validation */
    let validGpa = false;
    if (this.state.gpa !== '') {
      validGpa = true;
    } else {
      updated.gpaErrorMessage = 'Gpa is not valid.';
    }
      /* Gpa validation */

      /* Act validation */
    let validAct = false;
    if (this.state.act !== '') {
      validAct = true;
    } else {
      updated.actErrorMessage = 'Act is not valid.';
    }
      /* Act validation */

      /* Sat validation */
    let validSat = false;
    if (this.state.gpa !== '') {
      validSat = true;
    } else {
      updated.satErrorMessage = 'Sat is not valid.';
    }
      /* Sat validation */
      /* validation for academic info */
    const { yearOfPassing, gpa, sat, act, sportName, t40, school, height, weight,
          bench, squats, position, description, studentGender } = this.state;
    const academic = { yearOfPassing,
      gpa,
      sat,
      act,
      sportName,
      t40,
      bench,
      squats,
      position,
      description };

    const sports = {};
    let payload = this.props.profile.toJS();
    sports[sportName] = { t40, bench, squats, position, description };


    this.setState(updated, () => {
      payload = Object.assign(payload, {
        city: studentCity,
        sa_state: studentState,
        school,
        height,
        weight,
        year_of_graduation: yearOfPassing,
        academic,
        sports,
        fullname: studentFullName,
        gender: studentGender,
      });
      if (parentValidFullName && validStudentFullName && validStudentCity && validStudentState
              && validHeight && validWeight && validT40 && validDescription && validBench
              && validSquats && validSat && validAct && validGpa && validYearOfPassing &&
              validSchool) {
        this.props.saveSAProfile(payload, this.state.profile);
      }
    });
  }

  render() {
    const { parentFullNameErrorMessage, parentEmailErrorMessage,
          heightErrorMessage, weightErrorMessage,
        emailErrorMessage, studentFullNameErrorMessage, studentStateErrorMessage,
        studentCityErrorMessage, t40ErrorMessage, squatsErrorMessage,
            benchErrorMessage, descriptionErrorMessage, satErrorMessage, gpaErrorMessage,
            schoolErrorMessage, yearOfPassingErrorMessage, actErrorMessage } = this.state;
    const renderLoader = renderIf(this.props.saRequested || this.props.updateRequested);
    return (
      <div className={cn('col s12', styles.container)}>
        {renderLoader(
          <FullScreenLoader />,
          )}
        <div className={cn('col s12', styles.collapseContainer)}>
          <Collapsible
            trigger="Parent Info"
            transitionTime={100}
            contentOuterClassName={styles.bottomPadding}
            open={this.state.parentCollapsible}
          >
            <div className={styles.inputContainer}>
              <div className={parentFullNameErrorMessage === '' ? cn('col s6', styles.halfWidthWithSpan) : cn('col s6', styles.halfWidthWithSpanError)}>
                <span>FULL NAME</span>
                <Input
                  type="text"
                  name="full_name"
                  value={this.props.attributes.get('name')}
                  onFocus={() => this.removeErrorMessage('parentFullNameErrorMessage')}
                  onChange={val => this.handleChange('parentFullName', val)}
                />
                <Error message={this.state.parentFullNameErrorMessage} />
              </div>
              <div className={parentEmailErrorMessage === '' ? cn('col s12 m6', styles.halfWidthAutoComplete) : cn('col s12 m6', styles.halfWidthAutoCompleteError)}>
                <span>EMAIL</span>
                <Input
                  type="text"
                  name="email"
                  disabled
                  value={this.props.attributes.get('email')}
                />
                <Error message={parentEmailErrorMessage} />
              </div>
            </div>
          </Collapsible>
          <div className={styles.space} />
          <Collapsible
            trigger="Student Info"
            transitionTime={100}
            contentOuterClassName={styles.bottomPadding}
            open={this.state.parentCollapsible}
          >
            <div className={styles.inputContainer}>
              <div className={cn('col s8', styles.personalInfo)}>
                <div className={studentFullNameErrorMessage === '' ? cn('col s12', styles.halfWidthWithSpan) : styles.halfWidthWithSpanError}>
                  <span>FIRST NAME</span>
                  <Input
                    type="text"
                    name="full_name"
                    value={this.state.studentFullName}
                    onFocus={() => this.removeErrorMessage('studentFullNameErrorMessage')}
                    onChange={val => this.handleChange('studentFullName', val)}
                  />
                  <Error message={this.state.studentFullNameErrorMessage} />
                </div>
                <div className={studentStateErrorMessage === '' ? cn('col s12', styles.halfWidthWithSpan) : styles.halfWidthWithSpanError}>
                  <span>STATE</span>
                  <Input
                    type="text"
                    name="full_name"
                    value={this.state.studentState}
                    onFocus={() => this.removeErrorMessage('studentStateErrorMessage')}
                    onChange={val => this.handleChange('studentState', val)}
                  />
                  <Error message={this.state.studentStateErrorMessage} />
                </div>
                <div className={studentCityErrorMessage === '' ? cn('col s12', styles.halfWidthWithSpan) : styles.halfWidthWithSpanError}>
                  <span>CITY</span>
                  <Input
                    type="text"
                    name="full_name"
                    value={this.state.studentCity}
                    onFocus={() => this.removeErrorMessage('studentCityErrorMessage')}
                    onChange={val => this.handleChange('studentCity', val)}
                  />
                  <Error message={this.state.studentCityErrorMessage} />
                </div>
                <div className={cn('col s12 m6', styles.halfWidthRadio)}>
                  <p>GENDER</p>
                  <div className={cn('col s6', styles.radioContainer)}>
                    <RadioGroup name="gender" value={this.state.gender} onChange={val => this.handleChange('gender', val)}>
                      <RadioButton label="Male" value="male" />
                    </RadioGroup>
                  </div>
                  <div className={cn('col s6', styles.radioContainer)} >
                    <RadioGroup name="gender" value={this.state.gender} onChange={val => this.handleChange('gender', val)} >
                      <RadioButton label="Female" value="female" />
                    </RadioGroup>
                  </div>
                </div>
                {/* <div className={studentEmailErrorMessage === '' ?
                cn('col s12', styles.halfWidthWithSpan) : styles.halfWidthWithSpanError}>
                  <span>EMAIL</span>
                  <Input
                    type="text"
                    name="full_name"
                    value={this.state.studentEmail}
                    onFocus={() => this.removeErrorMessage('studentEmailErrorMessage')}
                    onChange={val => this.handleChange('studentEmail', val)}
                  />
                  <Error message={this.state.studentEmailErrorMessage} />
                </div> */}
              </div>
            </div>
            <div className={cn('col s4', styles.personalInfo)}>
              <img src="https://media.dev.myrecruitboard.com/Images/defaultProfile.jpg" alt="profile_ima" />
            </div>
          </Collapsible>
          <div className={styles.space} />
          <Collapsible
            trigger="Sports Info"
            transitionTime={100}
            contentOuterClassName={styles.bottomPadding}
            open={this.state.parentCollapsible}
          >
            <div className={styles.inputContainer}>
              <div className={heightErrorMessage === '' ? cn('col s6', styles.halfWidthWithSpan) : cn('col s6', styles.halfWidthWithSpanError)}>
                <span>HEIGHT</span>
                <Input
                  type="text"
                  name="full_name"
                  value={this.state.height}
                  onFocus={() => this.removeErrorMessage('heightErrorMessage')}
                  onChange={val => this.handleChange('height', val)}
                />
                <Error message={this.state.heightErrorMessage} />
              </div>
              <div className={weightErrorMessage === '' ? cn('col s12 m6', styles.halfWidthAutoComplete) : cn('col s12 m6', styles.halfWidthAutoCompleteError)}>
                <span>WEIGHT</span>
                <Input
                  type="text"
                  name="city"
                  value={this.state.weight}
                  onChange={val => this.handleChange('weight', val)}
                  onFocus={() => this.removeErrorMessage('weightErrorMessage')}
                />
                <Error message={weightErrorMessage} />
              </div>
              <div className={cn('col s12', styles.sportsInfo)}>
                <p>SPORTS DETAILS</p>
              </div>
              <div className={cn('col s12', styles.removePadding)}>
                <div className={emailErrorMessage === '' ? cn('col s12 m6', styles.halfWidthAutoComplete) : cn('col s12 m6', styles.halfWidthAutoCompleteError)}>
                  <span>MY SPORT</span>
                  <Input
                    type="text"
                    name="city"
                    value={this.state.mySport}
                  />
                  <Error message={emailErrorMessage} />
                </div>
                <div className={cn('col s6')}>
                  <span className={styles.makeAnotherPreference}>ADD PREFERENCE POSITIONS</span>
                </div>
              </div>
              <div className={cn('col s12', styles.textAreaContainer)}>
                <div className={descriptionErrorMessage === '' ? cn('col s12 ', styles.halfWidthWithSpan) : cn('col s12', styles.halfWidthWithSpanError)}>
                  <span>DESCRIPTION</span>
                  <Input
                    type="text"
                    name="city"
                    value={this.state.description}
                    onChange={val => this.handleChange('description', val)}
                    multiline
                    onFocus={() => this.removeErrorMessage('descriptionErrorMessage')}
                  />
                  <Error message={descriptionErrorMessage} />
                </div>
              </div>
              <div className={t40ErrorMessage === '' ? cn('col s12 m6', styles.halfWidthAutoComplete) : cn('col s12 m6', styles.halfWidthAutoCompleteError)}>
                <span>T40</span>
                <Input
                  type="text"
                  name="city"
                  value={this.state.t40}
                  onChange={val => this.handleChange('t40', val)}
                  onFocus={() => this.removeErrorMessage('t40ErrorMessage')}
                />
                <Error message={t40ErrorMessage} />
              </div>
              <div className={squatsErrorMessage === '' ? cn('col s12 m6', styles.halfWidthAutoComplete) : cn('col s12 m6', styles.halfWidthAutoCompleteError)}>
                <span>SQUATS</span>
                <Input
                  type="text"
                  name="city"
                  value={this.state.squats}
                  onChange={val => this.handleChange('squats', val)}
                  onFocus={() => this.removeErrorMessage('squatsErrorMessage')}
                />
                <Error message={squatsErrorMessage} />
              </div>
              <div className={benchErrorMessage === '' ? cn('col s12 m6', styles.halfWidthAutoComplete) : cn('col s12 m6', styles.halfWidthAutoCompleteError)}>
                <span>BENCH</span>
                <Input
                  type="text"
                  name="city"
                  value={this.state.bench}
                  onChange={val => this.handleChange('bench', val)}
                  onFocus={() => this.removeErrorMessage('benchErrorMessage')}
                />
                <Error message={benchErrorMessage} />
              </div>
            </div>
          </Collapsible>
          <div className={styles.space} />
          <Collapsible
            trigger="Academic Info"
            transitionTime={100}
            contentOuterClassName={styles.bottomPadding}
            open={this.state.parentCollapsible}
          >
            <div className={styles.inputContainer}>
              <div className={schoolErrorMessage === '' ? cn('col s12 m6', styles.halfWidthAutoComplete) : cn('col s12 m6', styles.halfWidthAutoCompleteError)}>
                <span>SCHOOL</span>
                <Input
                  type="text"
                  name="city"
                  value={this.state.school}
                  onChange={val => this.handleChange('school', val)}
                  onFocus={() => this.removeErrorMessage('schoolErrorMessage')}
                />
                <Error message={schoolErrorMessage} />
              </div>
              <div className={yearOfPassingErrorMessage === '' ? cn('col s12 m6', styles.halfWidthAutoComplete) : cn('col s12 m6', styles.halfWidthAutoCompleteError)}>
                <span>GRADUATION YEAR</span>
                <Input
                  type="text"
                  name="city"
                  value={this.state.yearOfPassing}
                  onChange={val => this.handleChange('yearOfPassing', val)}
                  onFocus={() => this.removeErrorMessage('yearOfPassingErrorMessage')}
                />
                <Error message={yearOfPassingErrorMessage} />
              </div>
              <div className={gpaErrorMessage === '' ? cn('col s12 m6', styles.halfWidthAutoComplete) : cn('col s12 m6', styles.halfWidthAutoCompleteError)}>
                <span>GPA</span>
                <Input
                  type="text"
                  name="city"
                  value={this.state.gpa}
                  onChange={val => this.handleChange('gpa', val)}
                  onFocus={() => this.removeErrorMessage('gpaErrorMessage')}
                />
                <Error message={gpaErrorMessage} />
              </div>
              <div className={satErrorMessage === '' ? cn('col s12 m6', styles.halfWidthAutoComplete) : cn('col s12 m6', styles.halfWidthAutoCompleteError)}>
                <span>SAT</span>
                <Input
                  type="text"
                  name="city"
                  value={this.state.sat}
                  onChange={val => this.handleChange('sat', val)}
                  onFocus={() => this.removeErrorMessage('satErrorMessage')}
                />
                <Error message={satErrorMessage} />
              </div>
              <div className={actErrorMessage === '' ? cn('col s12 m6', styles.halfWidthAutoComplete) : cn('col s12 m6', styles.halfWidthAutoCompleteError)}>
                <span>ACT</span>
                <Input
                  type="text"
                  name="city"
                  value={this.state.act}
                  onChange={val => this.handleChange('act', val)}
                  onFocus={() => this.removeErrorMessage('actErrorMessage')}
                />
                <Error message={actErrorMessage} />
              </div>
            </div>
          </Collapsible>
          <div className={styles.space} />
          <Button className={styles.continue} onClick={this.validateInput}>UPDATE PROFILE</Button>
        </div>
      </div>
    );
  }
}

export default ModifyParent;



// WEBPACK FOOTER //
// ./src/components/ModifyParent/ModifyParent.js